import React from 'react'

const CodingCard = ({ codeData: { name, skillPer } }) => {
    return (
        <li>
            <div className="name"> {name} </div>
            <div className={"progress p" + skillPer}>
                <span>{skillPer}%</span>
                <div className="slice"><div className="bar"></div><div className="fill"></div></div>
            </div>
        </li>
    );
}

export default CodingCard;